import React, {useState} from "react";
import "../../page/eczaciKimlikKart/EczaciKimlikKart.css";
import {Button, Checkbox, Form, Input, notification} from "antd";
import {pharmacyIdCardApplication} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import {useHistory} from "react-router-dom";
import {VirtualHost} from "../../constants";
import {resourcePrefixType} from "../../util/Enums";

function EczaciKimlikKartForm() {
    let history = useHistory();
    const [hasCard, setHasCard] = useState(false)

    function onFinish(values) {
        pharmacyIdCardApplication(JSON.stringify(values)).then((response) => {
            notification.success({
                message: "Başarılı",
                description: "Kart talebiniz başarılı bir şekilde alınmıştır. En kısa süre içerisinde sizinle iletişime geçilecektir.",
            })
            history.push("/")
        }).catch(error => {
            if (error.response.status === 422) {
                notification.warning({
                    message: "Uyarı",
                    description: `${error.response.data.message}`,
                })
                setHasCard(true);
            } else {
                showAxiosError(error.response);
            }
        })
    }

    return (
        <section
            className="skrollable u-clearfix u-image u-parallax u-shading u-section-2 kimlik-form-area"
            id="sec-c8b6"
            data-image-width="1060"
            data-image-height="706"
        >
            <div className="u-clearfix u-sheet u-sheet-1">
                <h2 className="u-align-left u-text u-text-custom-color-1 u-text-1">
                    Başvuru için;
                </h2>
                <Form onFinish={onFinish} layout="vertical">
                    <Form.Item
                        label="Adınız"
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen Adınızı Giriniz.",
                            },
                        ]}
                    >
                        <Input name="name" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="Soyadınız"
                        name="surname"
                        rules={[
                            {
                                required: true,
                                message: "Lütfen Soyadınızı Giriniz.",
                            },
                        ]}
                    >
                        <Input name="surname" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="T.C Kimlik Numaranız"
                        name="tckn"
                        rules={[
                            {
                                min: 11,
                                max: 11,
                                required: true,
                                message: "Lütfen T.C Kimlik Numaranızı Giriniz.",
                            },
                        ]}
                    >
                        <Input type="number" name="tckn" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="Telefon Numaranız (GSM)"
                        name="phoneNumber"
                        rules={[
                            {
                                min: 10,
                                max: 10,
                                required: true,
                                message: "Lütfen Telefon Numaranızı Giriniz. (5XXXXXXXXX)",
                            },
                        ]}
                    >
                        <Input type="number" name="phoneNumber" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="E-Posta Adresiniz"
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Lütfen E-Posta Adresinizi Giriniz.",
                            },
                        ]}
                    >
                        <Input name="email" size="large"/>
                    </Form.Item>
                    {((resourcePrefixType.tebeczacikart === VirtualHost.resourcePrefix && hasCard)
                        || (resourcePrefixType.optikkart === VirtualHost.resourcePrefix)) && <Form.Item name="lostPharmacyCard" valuePropName="checked">
                        <Checkbox>Kartımı Kaybettim</Checkbox>
                    </Form.Item>}

                    <Form.Item>
                        <Button type="primary" htmlType="submit" size="large">
                            Başvur
                        </Button>
                    </Form.Item>
                </Form>
                <h6 className="u-align-left u-text u-text-custom-color-1 u-text-2">
                    {VirtualHost.companyName}’a sahip olmak için formu doldurabilirsiniz.&nbsp;
                    Kısa sürede sizinle iletişime geçilecek, kart tarafınıza
                    iletilecektir.
                </h6>
            </div>
        </section>
    );
}

export default EczaciKimlikKartForm;



// WEBPACK FOOTER //
// ./src/component/EczaciKimlikKartForm/index.js